/*
  Toggles the Harit Zaveri header between its transparent top-of-page state and
  its solid scrolled state (Figma: NAV_NEW 8079:23028 -> Fixed_navbar 8106:26326
  — white fill, 0 2px 4px rgba(0,0,0,0.25), dark foreground).

  Driven by an IntersectionObserver on a zero-width sentinel rather than a
  scroll listener, so nothing runs on the scroll thread.

  Dawn's own StickyHeader (inline in sections/header.liquid) keeps ownership of
  the hide-on-scroll-down / reveal-on-scroll-up behaviour; this file only drives
  the colour and shadow swap, which Dawn has no equivalent for. The class it
  toggles is additive, so with JS disabled the header simply stays in its
  server-rendered state.
*/

(() => {
  const SENTINEL_ID = 'HeaderStickySentinel';

  let observer;

  function init() {
    const wrapper = document.querySelector('.header-wrapper--hz.header-wrapper--transparent');
    // Only the transparent variant has two states to switch between.
    if (!wrapper) return;
    if (!('IntersectionObserver' in window)) return;

    // The theme editor re-renders the section, leaving the previous observer
    // pointed at a detached wrapper.
    observer?.disconnect();
    document.getElementById(SENTINEL_ID)?.remove();

    const header = wrapper.querySelector('.header--hz') || wrapper;

    // Anchored to the document origin, not to the header: `.section-header` is
    // position: sticky, so an absolutely positioned child of it would travel
    // with the header and never leave the viewport.
    const sentinel = document.createElement('div');
    sentinel.id = SENTINEL_ID;
    sentinel.setAttribute('aria-hidden', 'true');
    // `display:block` is load-bearing: base.css hides `div:empty`, and a
    // display:none target never intersects, so the observer reported "past the
    // header" from the first frame and the bar was stuck solid at the top of
    // the page - the transparent state could never be seen. Inline wins over
    // that rule without needing !important.
    sentinel.style.cssText =
      'display:block;position:absolute;top:0;left:0;width:1px;pointer-events:none;visibility:hidden;';
    document.body.prepend(sentinel);

    const setSentinelHeight = () => {
      // Swap once the page has scrolled by roughly the header's own height,
      // matching where Dawn adds `.scrolled-past-header`.
      sentinel.style.height = `${Math.max(1, Math.round(header.offsetHeight))}px`;
    };

    setSentinelHeight();

    observer = new IntersectionObserver(
      ([entry]) => {
        wrapper.classList.toggle('header-wrapper--stuck', !entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(sentinel);

    if ('ResizeObserver' in window) {
      new ResizeObserver(setSentinelHeight).observe(header);
    } else {
      window.addEventListener('resize', setSentinelHeight);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
